import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ds-lib-help',
  templateUrl: './ds-lib-help.component.html',
  styleUrls: ['./ds-lib-help.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DsLibHelpComponent {
  /**
   *
   */
  @Input() matTooltipClass: 'tooltip-line-break' | 'tooltip-multiline-medium' = 'tooltip-line-break';

  /**
   * Whether to display line numbers
   */
  @Input() showLineNumbers = false;

  /**
   * Text displayed inside the tooltip
   */
  currentText = 'help text';

  /**
   * Array of strings to display inside the help tooltip
   */
  currentLines: string[] = [];

  /**
   * Sets text to be displayed after having formatted the array of strings into one.
   *
   * @param lines currentLines
   */
  @Input() set lines(lines: string[]) {
    this.currentLines = lines;
    this.setCurrentText(this.currentLines, this.showLineNumbers);
  }

  /**
   * Sets text to be displayed without formatting it.
   *
   * @param text currentText
   */
  @Input() set wholeText(text: string) {
    this.currentText = text;
  }

  /**
   * Sets the text that will be displayed by merging the array given in parameter
   * into one string separated by new lines \n. Line number can also be displayed.
   *
   * @param lines Array of lines to display
   * @param showLineNumbers showLineNumbers
   */
  setCurrentText(lines: string[], showLineNumbers: boolean) {
    if (!lines || (lines && lines.length === 0)) {
      return;
    }
    this.currentText = '';
    for (let i = 0; i < lines.length; i += 1) {
      if (showLineNumbers) {
        this.currentText += `${i + 1}. `;
      }
      this.currentText += lines[i];
      this.currentText += '\n';
    }
  }
}
